module.exports = __webpack_public_path__ + "static/media/agripreneurs_blog_poster.bdba1904.webp";